import React, { useState, useEffect }  from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./components/HomePage";
import FormularioPage from "./components/FormularioPage";


const App: React.FC = () => {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:vendedorId" element={<HomePage />} />
        <Route path="/form/:vendedorId" element={<FormularioPage />} />
      </Routes>
    </Router>
  );
};

export default App;